// Polyfill for WebGL detection issue in production
interface WindowWithGL extends Window {
  gl?: {
    createContext: () => null
  }
}

if (typeof window !== 'undefined' && !(window as WindowWithGL).gl) {
  (window as WindowWithGL).gl = {
    createContext: () => null
  };
}